import React, { useState, useEffect } from "react";
import logo_white from "../../assets/brand/pentalens-white.jpg";
import background_login from "../../assets/svg/background-login.svg";
import "./Auth.css";
import { AuthLogin } from "../../store/Actions/ActionAuth";
import { AbstructVar } from "../general/general-component/abstruct-component/AbstructVar";
import PasswordToggle from "./password-toggle/PasswordToggle";
import logo_dark from "../../assets/brand/pentalens-dark.png";

function Login() {
  let { navigate, dispatch, mode } = AbstructVar();
  const [loadBtn, setloadBtn] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [passwordInputType, ToggleIcon] = PasswordToggle();
  useEffect(() => {
    const storedEmail = localStorage.getItem("emailPent");
    const storedPassword = localStorage.getItem("passwordPent");
    const storedRememberMe = localStorage.getItem("rememberMePent");

    if (storedRememberMe === "true" && storedEmail && storedPassword) {
      setEmail(storedEmail);
      setPassword(storedPassword);
      setRememberMe(true);
    }
  }, []);
  const RoutToHome = (event) => {
    event.preventDefault();
    if (rememberMe) {
      localStorage.setItem("emailPent", email);
      localStorage.setItem("passwordPent", password);
      localStorage.setItem("rememberMePent", "true");
    } else {
      localStorage.removeItem("emailPent");
      localStorage.removeItem("passwordPent");
      localStorage.removeItem("rememberMePent");
    }
    dispatch(AuthLogin(email, password, navigate, setloadBtn));
  };
  return (
    <div className="page_login">
      {/* <div className='page_login_left' >
                <img src={background_login} />
            </div> */}
      <div className="page_login_right">
        {mode === "dark" ? <img src={logo_dark} /> : <img src={logo_white} />}
        <div class="sign-in-title">
          <h1>Sign in</h1>
          <br></br>
          <span>( Admin Login)</span>
        </div>
        <form className="form_login">
          <p className="form_login_p">Email</p>
          <input
            defaultValue={email}
            className="form_login_input"
            placeholder="EX: admin@admin.com"
            onChange={(e) => setEmail(e.target.value)}
          />
          <p className="form_login_p">Password</p>

          <div className="password-input-container">
            <input
              defaultValue={password}
              className="form_login_input"
              type={passwordInputType}
              placeholder="EX: 123hhg@"
              onChange={(e) => setPassword(e.target.value)}
            />

            <span className="pass_toggle_icon">{ToggleIcon}</span>
          </div>

          {/* <input defaultValue={password} className='form_login_input' type={passwordInputType} placeholder='EX: 123hhg@' onChange={(e) => setPassword(e.target.value)} />
                    <span className="pass_toggle_icon" >
                        {ToggleIcon}
                    </span> */}

          <div className="div_remember_me">
            <input
              className="checkbox"
              type="checkbox"
              id="rememberMe"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
            <p className="p_remember">Remember Me</p>
          </div>
          <button className="btn_login" onClick={RoutToHome}>
            {loadBtn ? "Loading ..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
